<template>
    <div class="mt-7 row movie-performances-row">
        <div class="mb-3 mb-lg-0 col-md-6 col-lg-3 d-flex align-items-center">
            <div>
                <h3 class="mb-0 color-black">
                    <a :href="'/bioscoop/' + cinemaSlug">
                        {{ cinemaName }}
                    </a>
                </h3>

                <span v-if="cinemaCity" class="font-size-small color-grey--dark">
                    {{ cinemaCity }}
                </span>
            </div>
        </div>

        <div v-if="cinemaWebsite" class="mb-3 mb-lg-0 col-md-6 d-none d-md-flex d-lg-none justify-content-end align-items-center">
            <a class="btn btn-primary box-shadow-default" :href="cinemaWebsite" target="_blank">
                Website
            </a>
        </div>

        <div v-for="time in times.slice(0, 7)" class="col-4 col-sm-3 col-lg-1">
            <div v-if="!time.ticketUrl" class="py-3 movie-single-performances-calendar-time">
                <span>
                    <span v-if="showDayInTimes" class="font-size-small">
                        {{ time.day }}
                    </span>
                    <span class="font-weight-extrabold">
                        {{ time.time }}
                    </span>
                </span>

                <div v-if="time.screen" class="mt-2 d-inline-block movie-single-performances-calendar-screen">
                    {{ time.screen }}
                </div>
            </div>

            <a v-if="time.ticketUrl"
               :href="time.ticketUrl"
               target="_blank"
               class="py-3 d-block movie-single-performances-calendar-time"
            >
                <span>
                    <span v-if="showDayInTimes" class="font-size-small">
                        {{ time.day }}
                    </span>
                    <span class="font-weight-extrabold">
                        {{ time.time }}
                    </span>
                </span>

                <div v-if="time.screen" class="mt-2 d-inline-block movie-single-performances-calendar-screen">
                    {{ time.screen }}
                </div>
            </a>
        </div>

        <div v-if="cinemaWebsite" class="mt-4 mt-md-0 ml-auto col-md-2 d-flex d-md-none d-lg-flex align-items-center">
            <a class="btn btn-primary box-shadow-default" :href="cinemaWebsite" target="_blank">
                Website
            </a>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            cinemaName: {
                type: String,
                required: true,
            },
            cinemaSlug: {
                type: String,
                required: true,
            },
            cinemaCity: {
                type: String,
            },
            cinemaWebsite: {
                type: String,
            },
            // Times are a {time, ticketUrl, screen} object, ticketUrl and screen are optional
            times: {
                type: Array,
                required: true,
            },
            showDayInTimes: {
                type: Boolean,
                default: false,
            },
        },
    };
</script>



// WEBPACK FOOTER //
// resources/js/components/movies/single/MoviePerformancesRow.vue